"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sticky = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const buttons_1 = require("../../atoms/buttons");
const useUpdateSelectedOption_1 = require("./useUpdateSelectedOption");
const Nav = styled_components_1.default.nav `
  display: block;
  position: relative;
  width: 100%;
  max-height: 100px;
  background-color: ${(props) => props.theme.colors.whiteBase};
  padding: ${(props) => props.theme.spacings.m}
    ${(props) => props.theme.spacings.xl} 2rem
    ${(props) => props.theme.spacings.xl};
  h1 {
    white-space: pre;
    &:empty:before {
      content: " ";
      display: block;
    }
  }
`;
const Options = styled_components_1.default.div `
  position: absolute;
  display: flex;
  bottom: 0;
  right: 1rem;
  margin-top: 2rem;

  & > button {
    background-color: transparent;
    border-color: transparent;
    padding: 0.5rem 1.5rem;
    width: auto;
  }

  & > button:nth-of-type(${({ selected }) => selected}) {
    background-color: ${({ theme }) => theme.colors.greyBase};
  }
`;
const Sticky = ({ options, onChange, children }) => {
    let initialSelected = 0;
    options === null || options === void 0 ? void 0 : options.forEach((option, index) => {
        option.selected && (initialSelected = index);
    });
    const [selectedOption, setOption] = (0, react_1.useState)(initialSelected);
    const selectOption = (option, idx) => {
        setOption(idx);
        option.onSelect && option.onSelect(option, idx);
        onChange && onChange(option, idx);
    };
    (0, useUpdateSelectedOption_1.useUpdateSelectedOption)(options || [], setOption);
    return ((0, jsx_runtime_1.jsxs)(Nav, { children: [children, (0, jsx_runtime_1.jsx)(Options, { selected: selectedOption + 1, children: options &&
                    options.map((option, idx) => ((0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: selectedOption === idx ? "primary" : "secondary", onClick: () => {
                            selectOption(option, idx);
                        }, children: option.label }, idx))) }, void 0)] }, void 0));
};
exports.Sticky = Sticky;
//# sourceMappingURL=sticky.js.map